export var Metrics;
(function (Metrics) {
    Metrics["importsLoadTime"] = "SmartTag.importsLoadTime";
    Metrics["aviaLoadTime"] = "SmartTag.aviaLoadTime";
    Metrics["importToCreateTime"] = "SmartTag.importToCreateTime";
    Metrics["createToLoadTime"] = "SmartTag.tag.createToLoadTime";
    Metrics["loadToAttachResourceTime"] = "SmartTag.tag.loadToAttachResourceTime";
    Metrics["attachToVideoStartTime"] = "SmartTag.tag.attachToVideoStartTime";
})(Metrics || (Metrics = {}));
